import {Row, Col} from 'antd';
import {fixedToDisplayUnit} from "../../util/unitutils";

export const DisplayCostWidget = ({item, props}) => {
    const displayQuantity = fixedToDisplayUnit(item.quantity, item.unit);
    const unitCost = item.cost / item.startQuantity;
    const totalCost = displayQuantity * unitCost;

    return <div>
        <Row style={{margin: "5px"}}><Col>{`$ ${totalCost.toFixed(2)}`}</Col></Row>
        <Row style={{margin: "5px"}}><Col>{`$ ${unitCost.toFixed(2)} / each`}</Col></Row>
    </div>
}